import { WSPill, WSFlexBox, WSText } from "@wingspanhq/fe-component-library";
import React from "react";
import { RouteComponentProps } from "react-router-dom";
import { queriesComplianceEntities, queriesPersons } from "@query";
import { useSession } from "@hooks/useSession";
import { formatPhone } from "../../../../../shared/utils/formatPhone";
import {
  useModalFirstNameEdit,
  useModalLastNameEdit,
  useModalPreferredNameEdit,
  useModalUserPasswordEdit
} from "./ModalEditSetting";
import { Setting } from "./Setting";

export const Account: React.FC<RouteComponentProps> = () => {
  const { personId } = useSession();
  const queryPerson = queriesPersons.getPerson.useQuery({ personId });
  const queryComplianceEntities =
    queriesComplianceEntities.listComplianceEntities.useQuery({});
  const primaryEntity = queryComplianceEntities.data?.data?.find(
    entity => !entity.subject
  );

  const passwordModal = useModalUserPasswordEdit();
  const preferredNameModal = useModalPreferredNameEdit();
  const legalFirstNameModal = useModalFirstNameEdit();
  const legalLastNameModal = useModalLastNameEdit();

  return (
    <>
      <WSText.Heading5 mb="2XL">Account Settings</WSText.Heading5>

      <Setting label="Email address">
        <WSFlexBox.CenterY>
          <WSText>{queryPerson.data?.email}</WSText>
          {queryPerson.data?.isEmailVerified && (
            <WSPill ml="XS" text="Verified" theme="success" />
          )}
        </WSFlexBox.CenterY>
      </Setting>

      <Setting label="Phone number">
        {queryPerson.data?.phone ? (
          <WSFlexBox.CenterY>
            <WSText>{formatPhone(queryPerson.data.phone)}</WSText>
            {queryPerson.data?.isPhoneVerified && (
              <WSPill ml="XS" text="Verified" theme="success" />
            )}
          </WSFlexBox.CenterY>
        ) : (
          <WSText color="gray500">Phone number is not added yet</WSText>
        )}
      </Setting>

      <Setting
        label="Password"
        onEdit={() => {
          passwordModal.open();
        }}
      >
        <WSText>*********</WSText>
      </Setting>

      <Setting
        label="Legal first name"
        description="Enter your first name exactly as it is recorded with government tax authorities."
        onEdit={() => {
          legalFirstNameModal.open();
        }}
      >
        {primaryEntity?.individualLegalName?.givenName ? (
          <WSText>{primaryEntity.individualLegalName.givenName}</WSText>
        ) : (
          <WSText color="gray500">First name is not added yet</WSText>
        )}
      </Setting>

      <Setting
        label="Legal last name"
        description="Enter your last name exactly as it is recorded with government tax authorities."
        onEdit={() => {
          legalLastNameModal.open();
        }}
      >
        {primaryEntity?.individualLegalName?.familyName ? (
          <WSText>{primaryEntity.individualLegalName.familyName}</WSText>
        ) : (
          <WSText color="gray500">Last name is not added yet</WSText>
        )}
      </Setting>

      <Setting
        label="Preferred name"
        description="A public-facing name that will appear to clients and contractors."
        onEdit={() => {
          preferredNameModal.open();
        }}
      >
        {primaryEntity?.preferredName ? (
          <WSText>{primaryEntity.preferredName}</WSText>
        ) : (
          <WSText color="gray500">Preferred name is not added yet</WSText>
        )}
      </Setting>
    </>
  );
};
